








































import {MyStudyChoiceOnboardingModelState} from "@/apps/MyStudyChoiceOnboardingWidget/models/store-viewmodel"
import {defineComponent} from "@vue/composition-api"
import {useActions, useGetters} from "vuex-composition-helpers"
import {ActionTree, GetterTree} from "vuex"
import ModalComponent from "@/apps/MyStudyChoiceOnboardingWidget/components/modal/ModalComponent.vue"
import CloseButtonAtom from "@/shared/components/atoms/CloseButtonAtom.vue"
import ButtonAtom from "@/shared/components/atoms/ButtonAtom.vue"
import {removeQueryString} from "@/apps/MyStudyChoiceOnboardingWidget/composables/queryString";

export default defineComponent({
    name: "CloseNotificationModal",
    components: {
        ModalComponent,
        CloseButtonAtom,
        ButtonAtom
    },
    setup: () => {
        const {getLabels} = useGetters<GetterTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'getLabels'
        ])
        const {
            setOnboardingIsActive, setOnboardingIsCompleted
        } = useActions<ActionTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'setOnboardingIsActive', 'setOnboardingIsCompleted'
        ]);

        function cancelCompletion(): void {
            setOnboardingIsCompleted(false).then(() => {
                setOnboardingIsActive(true)
            })
        }

        function completeOnboarding(): void {
            setOnboardingIsCompleted(true).then(() => {
                setOnboardingIsActive(false).then(() => {
                    removeQueryString(window.location.pathname)
                })
            })
        }

        return {
            getLabels,
            completeOnboarding,
            cancelCompletion
        }
    }
})
